// src/store/index.js
import { createStore } from 'vuex';
import organizations from './modules/organizations';
import sites from "./modules/sites";
import sections from "./modules/sections";
import wallpapers from "./modules/wallpapers";
import user from "./modules/user";
import hotRanking from "./modules/hotRanking";
import sitesDiy from "./modules/sitesDiy";

export default createStore({
    modules: {
        organizations,
        sections,
        sites,
        wallpapers,
        user,
        hotRanking,
        sitesDiy
    },
});
